import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  @Input() letters: string | undefined;
  @Input() largeAvatar = false;

  @Input() picture: string | undefined;

  constructor() {
  }

  ngOnInit() {
  }

}
